import React, { Component } from 'react'
import { DragDropContext } from 'react-beautiful-dnd'
import Category from './Category'
import ReorderHighlights from '../../queries/ReorderHighlights'
import { graphql, compose, withApollo } from 'react-apollo'
import styled from 'styled-components'


const Container = styled.div`
  margin-top: 15px;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`
const Title = styled.h3`
  height: 22px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  display: flex;
`
const SubTitle = styled.div`
  height: 19px;
  color: #6A6A6A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  display: flex;
  margin-bottom: 30px;
`
const Line = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #DBDBDC;
  margin-right: 15px;
  margin-bottom: 10px;
`

class Highlight extends Component {
  constructor(props) {
    super(props)
    const { highlights } = props.loan
    this.state = {
      highlights,
      categories: this.getCategories(highlights),
    }
  }

  _reorderHighligths = (highlightId, nextHighlightId) => {
    const { reorderHighlights } = this.props
    return reorderHighlights({
      variables: {
        input: {
          highlightId,
          nextHighlightId
        }
      }
    })
  }

  onDragStart = start => {
    let startIndex
    this.state.categories.map((category, index) => {
      if (category.title === start.source.droppableId) {
        startIndex = index
      }
    })
    // // Update the startIndex to the current state
    this.setState({
      startIndex,
    })
  }

  onDragEnd = result => {
    const { startIndex, categories } = this.state
    const category = categories[startIndex]
    const { source, destination, draggableId } = result

    if ( !destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
      return
    }

    const topics = Array.from(category.topics)
    topics.splice(source.index, 1)
    topics.splice(destination.index, 0, category.topics[source.index])
    const newCategory = {
      ...category,
      topics,
    }
    const updatedCategories = categories
    updatedCategories[startIndex] = newCategory
    this.setState({
      ...this.state,
      categories: updatedCategories,
      startIndex: null,
    })
    const nextHighlightId = newCategory.topics[destination.index+1] !== undefined ? newCategory.topics[destination.index+1].rid : null
    this._reorderHighligths(draggableId, nextHighlightId)
  }

  getCategory = highlights => {
    let result = {}
    const [{ category, guarantor }] = highlights
    result.id = category
    result.title = category === 'guarantor' ? "Guarantor : " + this.getTitle(guarantor.name) : this.getTitle(category)
    result.guarantorId = category === 'guarantor' ? guarantor.rid : null
    result.topics = highlights
    return result
  }

  filterToCategory = category => {
    const highlights = this.props.loan.highlights
    return highlights.filter(highlight => highlight.category === category)
  }

  getTitle = name => {
    return name.split('_').map(w =>  w.substring(0,1).toUpperCase()+ w.substring(1)).join(' ')
  }

  groupByGurantorId = (guarantors) => {
    return guarantors.reduce((acc, obj) => {
      const { rid } = obj.guarantor
      if (!acc[rid]) {
        acc[rid] = []
      }
      acc[rid].push(obj)
      return acc
    }, [])
  }

  getCategories = (highlights) => {
    const businessEntity = this.filterToCategory('business_entity')
    const guarantors = this.filterToCategory('guarantor')
    const otherApplicationDetails = this.filterToCategory('other_application_details')
    const bankSearches = this.filterToCategory('bank_search')
    let categories = []
    categories = [businessEntity, guarantors, otherApplicationDetails, bankSearches].filter(category => category.length > 0).map((highlight) => {
                      if (highlight === guarantors) {
                        return this.groupByGurantorId(guarantors).map((group) => this.getCategory(group))
                      } else {
                        return this.getCategory(highlight)
                      }
                    })
    return categories.flat(2)
  }

  render() {
    const { categories, startIndex } = this.state
    const { isBankUser, loanId } = this.props
    const title = 'Highlights'
    const subTitle = `${isBankUser? 'Review' : 'Provide'} highlights and notable details about the customer and their business.`
    return (
      <Container>
        <Header>
          <Title>{title}</Title>
        </Header>
        <Line/>
        <Header>
          <SubTitle>{subTitle}</SubTitle>
        </Header>
        <DragDropContext
          onDragStart={this.onDragStart}
          onDragEnd={this.onDragEnd}
        >

          {(categories.map((category, index) => {
            return (
              <Category
                key={category.id === 'guarantor'? category.title : category.id}
                category={category}
                loanId={loanId}
                isBankUser={isBankUser}
                topics={category.topics}
                isDropDisabled={index !== startIndex}
              />
            )
          })
          )}
        </DragDropContext>
      </Container>
    )
  }
}

export { Highlight }
export default compose(
  graphql(ReorderHighlights, {
    name: 'reorderHighlights'
  }),
  withApollo
)(Highlight)
